import { AxiosError } from 'axios';
import axiosInterseptor from '../../utils/axiosInterseptor';

export default class CatalogData {
  // Проверяет, нужно ли использовать режим filter
  static shouldUseFilterMode(filters?: string): boolean {
    if (!filters) return false;
    try {
      const parsedFilters = JSON.parse(filters);
      // Используем режим filter, если указаны комнаты, но нет дат бронирования
      return (
        parsedFilters?.rooms &&
        !parsedFilters?.booking &&
        !parsedFilters?.begin &&
        !parsedFilters?.end
      );
    } catch (e) {
      return false;
    }
  }

  // Получает страницу каталога
  static async getPage({
    page,
    cityId,
    order,
    filters,
    signal,
  }: {
    page: number;
    cityId: number;
    order?: string;
    filters?: string;
    signal?: AbortSignal;
  }) {
    const params: Record<string, any> = {
      id: cityId,
      order,
      filters,
      page,
    };

    // Определяем режим на основе фильтров
    if (this.shouldUseFilterMode(filters)) {
      params.mode = 'filter';
    } else {
      params.mode = 'search';
    }

    try {
      const response = await axiosInterseptor.get('/products/city', {
        params,
        signal,
      });

      const { data } = response;

      // Опционально: если в режиме filter мало результатов, пробуем search
      if (params.mode === 'filter' && data?.items?.length < 10) {
        const searchParams = { ...params, mode: 'search' };
        const searchResponse = await axiosInterseptor.get('/products/city', {
          params: searchParams,
          signal,
        });
        return searchResponse.data;
      }

      return data;
    } catch (error: any) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.details
      ) {
        throw new URIError(error.response.data.error.details);
      } else if (error.code === 'ERR_CANCELED') {
        throw new AxiosError('отмена', error.code);
      } else {
        throw new URIError('не удалось загрузить');
      }
    }
  }

  // Получает все элементы каталога
  static async getAll({
    cityId,
    order,
    filters,
    signal,
  }: {
    cityId: number;
    order?: string;
    filters?: string;
    signal?: AbortSignal;
  }) {
    const params: Record<string, any> = {
      id: cityId,
      order,
      filters,
    };

    // Определяем режим на основе фильтров
    if (this.shouldUseFilterMode(filters)) {
      params.mode = 'filter';
    } else {
      params.mode = 'search';
    }

    try {
      const response = await axiosInterseptor.get('/products/city', {
        params,
        signal,
      });

      const { data } = response;

      return data;
    } catch (error: any) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.details
      ) {
        throw new URIError(error.response.data.error.details);
      } else if (error.code === 'ERR_CANCELED') {
        throw new AxiosError('отмена', error.code);
      } else {
        throw new URIError('не удалось загрузить');
      }
    }
  }

  // Получает данные конкретной квартиры
  static async getApartament({
    apartamentId,
    begin,
    end,
    cashback,
  }: {
    apartamentId: string;
    begin?: string;
    end?: string;
    cashback?: boolean;
  }) {
    const params = {
      id: apartamentId,
      begin,
      end,
      cashback,
    };

    const response = await axiosInterseptor.get(`/products/product/${apartamentId}/data`, {
      params,
    });

    const { data } = response;
    return data;
  }

  // Получает районы города
  static async getAreas({ cityId }: { cityId: number }) {
    try {
      const params = {
        id: cityId,
      };
      const response = await axiosInterseptor.get(`/addreses/city/${cityId}/areas`, {
        params,
      });
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  // Получает координаты города
  static async getCityCoords({ cityId }: { cityId: number }) {
    try {
      const params = {
        id: cityId,
      };

      const response = await axiosInterseptor.get(`/addreses/city/${cityId}/coords`, {
        params,
      });
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  // Получает избранные объявления
  static async getPublicFavorite(
    id: Array<number>,
    page: number,
    signal: AbortSignal,
    cityId?: number,
  ) {
    if (axiosInterseptor) {
      let url = `/products/select?mode=filter&products=${JSON.stringify(id)}&page=${page}`;
      if (cityId !== undefined) {
        url += `&filters={"city":${cityId}}`;
      }
      try {
        const response = await axiosInterseptor.get(url, { signal });
        const { data } = response;
        return data;
      } catch (error) {
        return error;
      }
    }
    return null;
  }
}
